import React, { useState } from 'react';
import { MaximizeIcon, GridIcon } from 'lucide-react';
import { devices } from './data/devices';
import { DeviceFrame } from './components/DeviceFrame';
const VIDEO_ID = 'Mzw2ttJD2qQ';
const START_AT = 20;
export function App() {
  const [activeId, setActiveId] = useState<string>(devices[0].id);
  const [size, setSize] = useState<number>(620);
  const [scanlines, setScanlines] = useState<boolean>(true);
  const [playing, setPlaying] = useState<boolean>(false);
  const device = devices.find(d => d.id === activeId) ?? devices[0];
  return <main className="flex min-h-screen w-full flex-col bg-neutral-950 text-neutral-100" data-id="element-0" data-mp="2mjpwvhnj9igv">
      <header className="border-b border-neutral-800 px-5 py-4" data-id="element-1" data-mp="31c1igd3m7wgs">
        <h1 className="font-mono text-sm font-semibold uppercase tracking-[0.2em] text-neutral-200" data-id="element-2" data-mp="2wiyxgtcwlvc7">
          Terrible Screens Playground
        </h1>
        <p className="mt-1 font-mono text-xs text-neutral-500" data-id="element-3" data-mp="28s2ynca15zvg">
          One video, played on real devices at their real resolutions.
        </p>
      </header>

      <div className="flex flex-wrap items-center gap-2 border-b border-neutral-800 px-5 py-3" role="group" aria-label="Devices" data-id="element-4" data-mp="3ij61k21ff746">
        {devices.map(d => {
        const selected = d.id === activeId;
        return <button key={d.id} type="button" onClick={() => setActiveId(d.id)} aria-pressed={selected} className={`rounded-full border px-3 py-1.5 font-mono text-[11px] uppercase tracking-wider transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-400 ${selected ? 'border-neutral-100 bg-neutral-100 text-neutral-900' : 'border-neutral-800 text-neutral-400 hover:border-neutral-600 hover:text-neutral-100'}`} data-id="element-5" data-mp="6hqtghuuhen">
              {d.name}
              <span className="ml-2 opacity-60" data-id="element-6" data-mp="studrrrxgr8h">
                {d.width}×{d.height}
              </span>
            </button>;
      })}
      </div>

      <div className="flex flex-wrap items-center gap-5 border-b border-neutral-800 px-5 py-3" data-id="element-7" data-mp="38b6kw4i7udz">
        <label htmlFor="size" className="flex shrink-0 items-center gap-2 font-mono text-xs text-neutral-500" data-id="element-8" data-mp="3uf5gzkl3mb7q">
          <MaximizeIcon className="h-3.5 w-3.5" data-id="element-9" data-mp="85bc95xfyv4k" />
          Device size
        </label>
        <input id="size" type="range" min={320} max={1100} step={10} value={size} onChange={e => setSize(Number(e.target.value))} className="w-full max-w-xs accent-neutral-100" data-id="element-10" data-mp="3gkv2dw2tfxfe" />
        <span className="w-14 text-right font-mono text-xs tabular-nums text-neutral-400" data-id="element-11" data-mp="3qd0tl3l8uatj">
          {size}px
        </span>

        <button type="button" onClick={() => setScanlines(v => !v)} aria-pressed={scanlines} className={`ml-auto flex items-center gap-2 rounded-md border px-3 py-1.5 font-mono text-[11px] uppercase tracking-wider transition-colors ${scanlines ? 'border-neutral-100 bg-neutral-100 text-neutral-900' : 'border-neutral-800 text-neutral-400 hover:text-neutral-100'}`} data-id="element-12" data-mp="2xudaftpt55v3">
          <GridIcon className="h-3.5 w-3.5" data-id="element-13" data-mp="ydqulugxw728" />
          Pixel grid
        </button>
      </div>

      <div className="flex flex-1 items-center justify-center overflow-auto p-10" data-id="element-14" data-mp="13cll7il5ezww">
        <DeviceFrame device={device} size={size} videoId={VIDEO_ID} scanlines={scanlines} playing={playing} startAt={START_AT} onPlay={() => setPlaying(true)} data-id="element-15" data-mp="1r525lzscz3zd" />
      </div>
    </main>;
}